import React from "react";
import PropTypes from "prop-types";
import Form from "../../common/Form";
import Section from "../../common/Section";
import Fieldset from "../../common/Fieldset";
import Row from "../../common/Row";
import Col from "../../common/Col";
import AdresInput from "../../common/AdresInput";
import Table from "../../common/Table";
import RadioButtonGroup from "../../common/RadioButtonGroup";
import CheckBoxWithChild from "../../common/CheckBoxWithChild";
import { Popup } from 'semantic-ui-react';
import TextInput from "../../common/TextInput";
import Button from "../../common/Button";

const AdresForm = (props) => {
    const {
        adressen,
        goToNext,
        goToPrev,
        clickAdd,
        cancelAdd,
        saveAdd,
        addMode,
        editingAdres,
        landen,
        postcodeGemeenten,
        straten,
        huisnummers,
        busnummers,
        adresTypes,
        onChange,
        errors,
        onDelete,
        deletingAdresId,
        showUnknownToPartnerModal,
        confirmUnknownAdres,
        closeUnknownAdresModal
    } = props;

    function returnTdContent(text) {
        return text.length > 90 ? <Popup wide="very" position="top left" trigger={<p>{text.substring(0, 80) + "..."}</p>} content={text} /> : text;
    }

    function mapOnDelete(id) {
        return function (event) {
            onDelete(id, event);
        };
    }

    const tdStyle = { padding: "5px" };

    const hasMaatschappelijkAdres = adressen && adressen.filter(x => x.soortAdres === 1).length > 0;

    const belgischeAdressen = adressen ? adressen.filter(x => x.land === "BE").map((adres, i) => {
        const postcodeEnGemeente = (adres.postcode ? adres.postcode : "") + " " + (adres.gemeente ? adres.gemeente : "");
        const nrEnBus = (adres.huisnummer ? adres.huisnummer : "") + (adres.busnummer ? "/" + adres.busnummer : "");
        const landNaam = adres.land ? landen.find(x => x.value === adres.land).label : '';
        const soortAdresNaam = adres.soortAdres ? (adres.soortAdres === 3 ? "Plaats waar wedstrijden/trainingen doorgaan" : adresTypes.find(x => x.value === adres.soortAdres).label) : '';
        return (
            <tr style={{ borderStyle: 'solid', borderWidth: "1px", borderColor: '#eeefef', height: '80' }} key={i}>
                <td style={tdStyle}>{soortAdresNaam}</td>
                <td style={tdStyle}>{adres.straat}</td>
                <td style={tdStyle}>{nrEnBus}</td>
                <td style={tdStyle}>{postcodeEnGemeente}</td>
                <td style={tdStyle}>{landNaam}</td>
                <td style={tdStyle}>
                    <Popup trigger={<span onClick={addMode ? null : mapOnDelete(adres.id)} style={{ color: addMode ? '#eeefef' : '#777', fontSize: '1rem', cursor: addMode ? 'not-allowed' : 'pointer' }}><i className="fa fa-remove fa-fw"></i></span>} content={"Verwijder adres"} />
                </td>
            </tr>
        );
    }) : [];

    const internationaleAdressen = adressen ? adressen.filter(x => x.land !== "BE").map((adres, i) => {
        const landNaam = adres.land ? landen.find(x => x.value === adres.land).label : '';
        const soortAdresNaam = adres.soortAdres ? (adres.soortAdres === 3 ? "Plaats waar wedstrijden/trainingen doorgaan" : adresTypes.find(x => x.value === adres.soortAdres).label) : '';
        return (
            <tr style={{ borderStyle: 'solid', borderWidth: "1px", borderColor: '#eeefef', height: '80' }} key={i}><td style={tdStyle}>{soortAdresNaam}</td>
                <td style={tdStyle}>{returnTdContent(adres.internationaalAdres)}</td>
                <td style={tdStyle}>{landNaam}</td>
                <td style={tdStyle}>
                    <Popup trigger={<span onClick={addMode ? null : mapOnDelete(adres.id)} style={{ color: addMode ? '#eeefef' : '#777', fontSize: '1rem', cursor: addMode ? 'not-allowed' : 'pointer' }}><i className="fa fa-remove fa-fw"></i></span>} content={"Verwijder adres"} />
                </td>
            </tr>
        );
    }) : [];

    return (
        <Section>
            <Form
                name="adres"
                headerVisible={false}
                isNotRequired
            >
                <Fieldset>
                    <Row><div style={{ color: "#082b42", fontSize: "1.4375rem", fontWeight: "500", lineHeight: "28px", margin: "30px 0.83333% 0 0.83333%" }}>Adressen</div></Row>
                </Fieldset>
                <div style={{ width: "100%", height: "1px", backgroundColor: "#E6E6E6", marginTop: "30px" }}></div>
                <Fieldset>
                    {adressen && adressen.length > 0 ?
                        <div>
                            {belgischeAdressen && belgischeAdressen.length > 0 && internationaleAdressen && internationaleAdressen.length > 0 ?
                                <h2 style={{ color: "#777" }}>Belgische adressen</h2> : null}
                            {belgischeAdressen && belgischeAdressen.length > 0 ?
                                <Table
                                    headers={["Soort Adres", "Straatnaam", "Nr - Bus", "Postcode - Gemeente", "Land", ""]}
                                    headerSizes={[26, 24, 10, 18, 14, 4]}
                                    containerMargin={"0 0 30px 0"}
                                >
                                    {belgischeAdressen}
                                </Table> : null}

                            {belgischeAdressen && belgischeAdressen.length > 0 && internationaleAdressen && internationaleAdressen.length > 0 ?
                                <h2 style={{ color: "#777" }}>Internationale adressen</h2> : null}
                            {internationaleAdressen && internationaleAdressen.length > 0 ?
                                <Table
                                    headers={["Soort Adres", "Internationaal adres", "Land", ""]}
                                    headerSizes={[26, 46, 20, 4]}
                                >
                                    {internationaleAdressen}
                                </Table> : null}
                        </div>
                        :
                        <p style={{ marginBottom: "20px" }}>Er werd nog geen adres toegevoegd.</p>
                    }

                    {addMode ?
                        <div>
                            <h2 style={{ color: "#777" }}>Toevoegen adres</h2>
                            <Row>
                                <Col style={{ marginTop: "21px" }} size={2}>Soort adres:</Col>
                                <Col size={10}>
                                    <RadioButtonGroup
                                        name="soortAdres"
                                        value={editingAdres.soortAdres}
                                        onChange={onChange}
                                        items={hasMaatschappelijkAdres ?
                                            [
                                                { value: "3", label: "Plaats waar wedstrijden/trainingen doorgaan" },
                                                { value: "2", label: "Correspondentieadres" }
                                            ] :
                                            [
                                                { value: "3", label: "Plaats waar wedstrijden/trainingen doorgaan" },
                                                { value: "1", label: "Maatschappelijke zetel" },
                                                { value: "2", label: "Correspondentieadres" }
                                            ]}
                                        noBorder
                                        horizontal
                                    />
                                </Col>
                            </Row>
                            {editingAdres.soortAdres === "3" ?
                                <Row>
                                    <TextInput
                                        name="omschrijvingLocatie"
                                        label="Omschrijving locatie"
                                        value={editingAdres.omschrijvingLocatie}
                                        onChange={onChange}
                                        validationMessage={errors ? errors['omschrijvingLocatie'] : ""}
                                    />
                                </Row>
                                : null}
                            <AdresInput
                                model={editingAdres}
                                landen={landen}
                                postcodeGemeenten={postcodeGemeenten}
                                straten={straten}
                                huisnummers={huisnummers}
                                busnummers={busnummers}
                                adresTypes={adresTypes}
                                onChange={onChange}
                                errors={errors}
                                showUnknownToPartnerModal={showUnknownToPartnerModal}
                                confirmUnknownAdres={confirmUnknownAdres}
                                closeUnknownAdresModal={closeUnknownAdresModal}
                            />
                            <CheckBoxWithChild
                                name={"toonOpKaart"}
                                value={editingAdres.toonOpKaart}
                                label={"De locatie van dit adres mag getoond worden op de website van Sport Vlaanderen."}
                                onChange={onChange}
                            />
                            <Row style={{ margin: "40px 0 -40px 0" }}>
                                <Button text={"Annuleer"} onClick={cancelAdd} className="c-button--left" style={{ "float": "left", "margin": "0 0.83333% 0 0", "minWidth": "200px" }} />
                                <Button text={"Bewaar"} onClick={saveAdd} style={{ "minWidth": "200px", "float": "right" }} />
                            </Row>
                        </div> :
                        <Row style={{ margin: "0 0 -40px 0" }}>
                            <Button text={"Terug"} onClick={goToPrev} className="c-button--left" style={{ "float": "left", "margin": "0 0.83333% 0 0", "minWidth": "200px" }} disabled={deletingAdresId !== null} />
                            <Button text={"Voeg toe"} onClick={clickAdd} className="c-button--left" style={{ "minWidth": "200px" }} disabled={deletingAdresId !== null} />
                            <Button text={"Ga verder"} onClick={goToNext} style={{ "minWidth": "200px", "float": "right" }} disabled={deletingAdresId !== null} />
                        </Row>
                    }
                </Fieldset>
            </Form>
        </Section>
    );
};

AdresForm.propTypes = {
    adressen: PropTypes.array,
    goToNext: PropTypes.func,
    goToPrev: PropTypes.func,
    clickAdd: PropTypes.func,
    cancelAdd: PropTypes.func,
    saveAdd: PropTypes.func,
    addMode: PropTypes.bool,
    editingAdres: PropTypes.object,
    landen: PropTypes.array,
    postcodeGemeenten: PropTypes.array,
    straten: PropTypes.array,
    huisnummers: PropTypes.array,
    busnummers: PropTypes.array,
    adresTypes: PropTypes.array,
    onChange: PropTypes.func,
    errors: PropTypes.object,
    onDelete: PropTypes.func,
    deletingAdresId: PropTypes.object,
    showUnknownToPartnerModal: PropTypes.bool,
    confirmUnknownAdres: PropTypes.func,
    closeUnknownAdresModal: PropTypes.func,
};

export default AdresForm;